module.exports = __webpack_public_path__ + "static/battle_08-08edd2f56352136821b293abc1568276.jpg";